// A package's address on Discover (keepr-api KPR-358, docs/SCHEMA.md "A
// package's key and its publisher"). keepr's own packages have bare keys and
// open at /discover/<key>, as they always did; a package another publisher
// publishes is keyed `<publisher>/<name>` and opens at
// /discover/<publisher>/<name> — two segments, each encoded. The API takes
// the same key as ONE path segment with its slash encoded, which is what
// services/packages.js's encodeURIComponent(key) already sends.
//
// Every link to a package page is built here, so no surface spells the
// address on its own.

/** The package page's path for `key`, with the listing preset it was opened from (KPR-383) when there is one. */
export function packagePath(key, { listing = null } = {}) {
	const path = `/discover/${String(key || '').split('/').map(encodeURIComponent).join('/')}`;
	return listing ? `${path}?listing=${encodeURIComponent(listing)}` : path;
}

/**
 * The key a package page's route names: `/discover/:packageKey` (a bare key)
 * or `/discover/:publisher/:name` (a namespaced one). '' when neither.
 */
export function packageKeyOf(params) {
	const { packageKey, publisher, name } = params || {};
	if (packageKey) return packageKey;
	return publisher && name ? `${publisher}/${name}` : '';
}

/** `{ publisher, name }` of a namespaced key, or null for a bare one. */
export function namespaceOf(key) {
	const k = String(key || '');
	const at = k.indexOf('/');
	return at === -1 ? null : { publisher: k.slice(0, at), name: k.slice(at + 1) };
}
